import { initializeApp } from 'firebase/app';
import { Auth, getAuth } from 'firebase/auth';
import { Firestore, getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import firebaseConfig from './firebase-applet-config.json';

let app;
let auth: Auth;
let db: Firestore;
let storage: FirebaseStorage;

try {
  console.log("[Firebase] Initializing with config:", JSON.stringify({ ...firebaseConfig, apiKey: '***' }));
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app, firebaseConfig.firestoreDatabaseId);
  
  // Enable offline persistence to minimize reads on refresh
  if (typeof window !== 'undefined') {
    enableIndexedDbPersistence(db).catch((err) => {
      if (err.code === 'failed-precondition') {
        console.warn("[Firebase] Persistence failed: Multiple tabs open");
      } else if (err.code === 'unimplemented') {
        console.warn("[Firebase] Persistence failed: Browser not supported");
      }
    });
  }
  
  storage = getStorage(app);
  console.log("[Firebase] Initialization successful");
} catch (error) {
  console.error("[Firebase] Initialization failed:", error);
}

export { auth, db, storage };
